import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Play } from "lucide-react";

export const Hero = () => {
  return (
    <section className="py-20 lg:py-32">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-secondary rounded-full text-primary text-sm font-medium mb-6">
              <span>🚀 Proven results: 23% higher revenue, 90% fewer late payments</span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-foreground mb-8 leading-tight">
              Effortless Property Management
              <span className="text-primary block">Starts Here</span>
            </h1>

            <p className="text-xl md:text-2xl text-muted-foreground mb-12 max-w-3xl mx-auto leading-relaxed">
              From tenant chaos to calm control — collect rent, resolve maintenance, and keep tenants happy with a
              platform built to scale your rental business.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link to="/signup">
                <Button size="lg" className="px-8 py-4 text-lg">
                  Start Free Trial
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>

              <Button variant="outline" size="lg" className="px-8 py-4 text-lg">
                <Play className="mr-2 h-5 w-5" />
                Watch Demo
              </Button>
            </div>

            <p className="text-sm text-muted-foreground mt-6">No credit card required • Freemium • Cancel anytime</p>
          </div>

          {/* Hero Image Placeholder */}
          <div className="relative">
            <div className="bg-gradient-to-r from-primary to-primary/80 rounded-2xl shadow-2xl p-8 text-primary-foreground">
              <div className="bg-card/10 backdrop-blur-sm rounded-xl p-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="text-center">
                    <div className="text-3xl font-bold">98%</div>
                    <div className="text-sm opacity-80">On-time payments</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold">24hrs</div>
                    <div className="text-sm opacity-80">Avg response time</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold">$2.4M</div>
                    <div className="text-sm opacity-80">Rent collected monthly</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
